// src/App.js
import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

// GOOGLE OAUTH (ADDED)
import { GoogleOAuthProvider } from '@react-oauth/google'

// Import your routes
import AppRoutes from './routes/AppRoutes'

// Optional global styles
import './App.scss'

// 1) Load your Stripe publishable key (environment or hard-coded)
const stripePubKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  ? process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
  : 'pk_live_51QixgjP3k4U26NaVg61VHJaso0ypSkoLbvXq8RYLVp1mYoVSnfEBwreIB5BBLZdBkOxWSNkNc3lipkyn4AQkFDLE00X6tCMSQp'

const stripePromise = loadStripe(stripePubKey)

// 2) Hardcode your Google Client ID here
const googleClientId = '713827320947-ngen4vc8enffk63m8g1hivenkdbgv6jq.apps.googleusercontent.com' // <--- Replace with YOUR ID

function App() {
  return (
    // Wrap your entire app with GoogleOAuthProvider
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        {/* Wrap your app in Stripe’s <Elements> provider */}
        <Elements stripe={stripePromise}>
          {/* We only render AppRoutes at the top level now */}
          <AppRoutes />
        </Elements>
      </BrowserRouter>
    </GoogleOAuthProvider>
  )
}

export default App
